import * as types from "../actions/ActionTypes";
import UrlHelper from "../utilities/UrlHelper";
import { getErrorMessage } from "../utilities/ErrorMessageHelper";

export const getInitialState = () => (
    {
        applications: [],
        appLinks: {},
        superUserToolUrls: {},
        redirectTo: null,
        currentUser: null,
        browsers: [],
        openInNewWindow: null,
    });

const appReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_AVAILABLE_APPLICATION_SUCCEEDED: {
        return Object.assign({}, state, { applications: action.apps });
    }
    case types.GET_SUPERUSER_LINKS_SUCCEEDED: {
        return Object.assign({}, state, {
            superUserToolUrls: action.links
        });
    }
    case types.GET_APPLICATION_LINKS_SUCCEEDED: {
        const data = {};
        data.s797Url = action.appLinks.S797Url;
        data.staffReadyUrl = "https://tom6.maplewoodsoftware.com/StaffReady/LoginPage/Apps?3%20";
        if (!action.showLoginPageUrls) {
            if (action.appLinks.QuantifiUrl) {
                data.quantifiUrl = action.appLinks.QuantifiUrl;
            }
            if (action.appLinks.Sentri7Url) {
                data.sentri7Url = action.appLinks.Sentri7Url;
            }
            if (action.appLinks.VeriformUrl) {
                data.veriformUrl = action.appLinks.VeriformUrl;
            }
            if (action.appLinks.PocAdvisorUrl) {
                data.pocAdvisorUrl = action.appLinks.PocAdvisorUrl;
            }
        }
        else {
            data.quantifiUrl = UrlHelper.getIdentifiUrl() + "auth/login/?a=q";
            data.veriformUrl = UrlHelper.getIdentifiUrl() + "auth/login/?a=v";
            data.sentri7Url = UrlHelper.getIdentifiUrl() + "auth/login/?a=s7";
            data.pocAdvisorUrl = UrlHelper.getIdentifiUrl() + "auth/login/?a=pa";
        }

        return Object.assign({}, state, { appLinks: data });
    }
    case types.CHANGE_USER_PASSWORD_AND_LOGIN_SUCCEEDED:
    case types.IMPERSONATION_SUCCEEDED:
    case types.START_LOGIN_SUCCEEDED:
    case types.START_SSO_LOGIN_SUCCEEDED:
    case types.LINK_USER_SUCCEEDED:
        return Object.assign({}, state, { redirectTo: action.url, openInNewWindow: false });
    case types.GET_CURRENT_USER_SUCCEEDED:
        return Object.assign({}, state, { currentUser: action.user });
    case types.GET_SUPPORTED_BROWSERS_SUCCEEDED:
        return Object.assign({}, state, { browsers: action.browsers });
    case types.GET_SUPPORTED_BROWSERS_FAILED:
        return Object.assign({}, state, { browsers: []});
    case types.LOGIN_TO_SISENSE_SUCCEEDED:
        return Object.assign({}, state, { redirectTo: action.url, openInNewWindow: true });
    default:
        return state;
    }
};

export default appReducer;
